/**
 * Created by ChrisMuto on 7/13/17.
 */

export const NOTIFICATION_LEVEL_ERROR = "NOTIFICATION_LEVEL_ERROR";
export const NOTIFICATION_LEVEL_INFO = "NOTIFICATION_LEVEL_INFO";
export const NOTIFICATION_LEVEL_SUCCESS = "NOTIFICATION_LEVEL_SUCCESS";



// WEBPACK FOOTER //
// ./src/modules/notifications/constants.js